import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  };
  return <section className="w-full py-20 lg:py-28" data-id="element-535">
      <div className="container mx-auto" data-id="element-536">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto text-center" data-id="element-537">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-538">
            Join the lab
          </p>
          <h2 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground" data-id="element-539">
            Early access, batch updates, and{' '}
            <span className="font-mono text-primary" data-id="element-540">10%</span> off your first
            order.
          </h2>
          <p className="mt-5 text-[15px] text-muted-foreground leading-relaxed max-w-xl mx-auto" data-id="element-541">
            One email a month. New batches, new peptides, occasional research
            notes. Unsubscribe anytime.
          </p>

          {submitted ? <div className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary/10 text-primary text-sm font-medium" data-id="element-542">
              <CheckCircle2 className="h-4 w-4" data-id="element-543" />
              You're on the list. Check your inbox.
            </div> : <form onSubmit={onSubmit} className="mt-8 flex flex-col sm:flex-row items-stretch gap-3 max-w-md mx-auto" data-id="element-544">
              <Input type="email" required placeholder="you@email.com" value={email} onChange={e => setEmail(e.target.value)} className="rounded-full h-12 px-5 bg-card" aria-label="Email address" data-id="element-545" />
              <Button type="submit" size="lg" className="rounded-full px-6" data-id="element-546">
                Subscribe{' '}
                <ArrowRight className="h-4 w-4 ml-1" strokeWidth={2} data-id="element-547" />
              </Button>
            </form>}

          <p className="mt-5 text-[11px] text-muted-foreground" data-id="element-548">
            By subscribing you agree to our privacy policy. No spam — ever.
          </p>
        </motion.div>
      </div>
    </section>;
}